export default {
  list: '/auth/trade/findList', // 列表
  managementList: '/manage/trade/findList', // 管理列表
  productPrd: '/auth/trade/getBasfProductsByPrd', // prd 模糊查询
  productName: '/auth/trade/findBasfTradesByName', // basf product name 模糊查询
  getInci: '/auth/trade/inci/findInciFilter',
  getDetail: '/auth/trade/findDetail',
  getManagementDetail: '/manage/trade/findDetail',
  approve: '/manage/trade/approval', // 审批
  export: '/manage/trade/export', // 导出
  add: '/auth/trade/saveOrSubmitTrades', // 新增
  withdraw: '/auth/trade/withdraw',
  getCount: '/auth/trade/countTrade', // 获取pending计数
  getInciName: '/auth/trade/inci/findInciByIds',
  getLastApprovalDate: '/manage/trade/getLastApprovalDate', // 获取最后更新时间
  enableOperate: '/manage/trade/enableOperate',
  setKeyProduct: '/manage/trade/key/set',
  setSampleRequest: '/manage/trade/sampleRequest',
  getUploadTradeCount: '/auth/trade/myCountTrade',
  deleteDraft: '/auth/trade/delete'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/BASFProduct.js